export default __webpack_public_path__ + "static/media/gp-title-cn.e1cdf87f.webp";